const PHRASES = [
  "Know your real numbers",
  "Know your clinic",
  "Know where you're going",
  "No assumptions",
  "No scattered systems",
  "Just clarity",
];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {PHRASES.map((p) => (
      <span key={p} className="flex items-center">
        <span className="whitespace-nowrap px-6 text-sm font-medium uppercase tracking-[0.22em] text-slate-500">{p}</span>
        <span className="h-1.5 w-1.5 rounded-full bg-brand" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="overflow-hidden border-y border-slate-200/80 bg-white py-4" data-testid="brand-marquee">
    <div className="animate-marquee flex w-max">
      <Row />
      <Row hidden />
    </div>
  </div>
);

export default Marquee;
